module.exports = __webpack_public_path__ + "static/img/mbSwiper.8e60634.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/appDownLoad/mob/mbSwiper.jpg
// module id = GBo8
// module chunks = 1